import { EventCondensed } from '@core/models/tickets/Ticket';
import { EventType, EventStatus } from '@core/models/tickets/enums';
import {
    SportEvent,
    SportSelection,
    SpecialEvent,
    SpecialSelection,
} from './types';

export function createSportSelection(ticketEvent: EventCondensed): SportSelection {
    const [
        team1Name,
        team2Name,
    ] = ticketEvent.name.split('-');
    const event: SportEvent = {
        team1Name,
        team2Name,
        date: ticketEvent.date!,
        eventNo: ticketEvent.eventNo,
        isLive: ticketEvent.type === EventType.live && ticketEvent.status === EventStatus.active,
        wasLive: ticketEvent.type === EventType.live && ticketEvent.status !== EventStatus.active,
        status: ticketEvent.status,
        id: ticketEvent.eventId,
    };

    return {
        event,
        isSpecialType: false,
        odd: {
            value: ticketEvent.odd.coefficient,
            id: ticketEvent.odd.oddId,
            symbol: ticketEvent.odd.name,
            specialBetValue: ticketEvent.odd.specialValue,
        },
        marketName: ticketEvent.market.name,
    };
}

export function createSpecialSelection(ticketEvent: EventCondensed): SpecialSelection {
    const event: SpecialEvent = {
        date: ticketEvent.date!,
        eventNo: ticketEvent.eventNo,
        isLive: false,
        wasLive: false,
        team1Name: ticketEvent.teamNameOne || ticketEvent.name,
        status: ticketEvent.status,
        id: ticketEvent.eventId,
    } as SpecialEvent;

    return {
        event,
        isSpecialType: true,
        odd: {
            id: ticketEvent.odd.oddId,
            value: ticketEvent.odd.coefficient,
            symbol: ticketEvent.odd.name,
            specialBetValue: ticketEvent.odd.specialValue,
        },
        marketName: ticketEvent.market ? ticketEvent.market.name : '',
    };
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--12!./src/app/utils/mappers/TicketEventToSelectionProps.ts